export default {
    layout: {
        loading: 'Đang giao dịch',
        trading: 'Đang giao dịch'
    },
    footer: {
    },
    menu: {
        home: 'Trang chủ',
        staking: 'Ma trận',
        port: 'PORT',
        internet: 'Mạng',
        me: 'Của tôi'
    },
    header: {
        selectLang: 'Chọn ngôn ngữ',
        close: 'Đóng',
        trading: 'Giao dịch',
        dashboard: 'Bảng điều khiển',
        subscribeMatrix: 'Đăng ký Ma trận',
        portTaskCenter: 'Trung tâm nhiệm vụ PORT',
        network: 'Mạng',
        apiBinding: 'Liên kết API',
        gridTree: 'Cây lưới',
        account: 'Tài khoản',
        documents: 'Tài liệu & Whitepaper',
        personalCenter: 'Trung tâm cá nhân',
        language: 'Ngôn ngữ'
    },
    home: {
        recently1:'Cộng đồng',
        staticrewares: 'Tĩnh',
        recentlyName: 'Sổ cái',
        recentlyInfo: 'Chi tiết thu nhập',
        dataUpdate: 'Cập nhật dữ liệu',
        realtime: 'Thời gian thực · BSC',
        totalRevenue: 'Tổng doanh thu (USDT)',
        today: 'Hôm nay',
        totalTradingVolume: 'Tổng khối lượng giao dịch',
        todayEarn: 'Thu nhập hôm nay',
        share: 'Chia sẻ với bạn bè',
        shareDesc: 'Hiển thị thu nhập, mời và nhận thưởng',
        directReferrals: 'Giới thiệu trực tiếp',
        teamMembers: 'Thành viên nhóm',
        thisWeek: 'Tuần này',
        copy: 'Sao chép',
        recently: 'Thu nhập gần đây',
        netIncome: 'Thu nhập ròng',
        dailyAverage: 'Trung bình hàng ngày',
        quantitativeIncome: 'Thu nhập định lượng',
        recommend: 'Đề xuất',
        port: 'PORT',
        bonus: 'Thưởng',
        all: 'Tất cả',
        todayTitle: 'Hôm nay',
        loadingMore: 'Tải thêm',
        recommendBonus: 'Thưởng giới thiệu',
        portTaskPassed: 'Nhiệm vụ PORT đã hoàn thành',
        myProfit: 'Lợi nhuận của tôi',
        earningOnBitDeep: 'Đang kiếm tiền trên BitDeep',
        totalRevenueUsdt: 'Tổng doanh thu · USDT',
        consecutiveDays: 'Ngày liên tiếp',
        scanToJoin: 'Quét để tham gia',
        uid: 'UID',
        referralBonus: 'Thưởng giới thiệu',
        shareTo: 'Chia sẻ tới',
        eachReferral: 'Thưởng chia sẻ',
        screenshotAndShare: 'Chụp màn hình và chia sẻ',
        saveShareEarn: 'Lưu · Chia sẻ · Kiếm tiền',
        period: 'Kỳ hạn',
        netProfit: 'Lợi nhuận ròng',
        quantReward: 'Thưởng định lượng',
        dailyBonus: 'Thưởng hàng ngày PORT',
        close: 'Đóng',
        permission: 'Quyền',
        onlyEnable: 'Chỉ bật',
        enterBitgetUid: 'Nhập BITGET UID',
        slogan: 'Khẩu hiệu',
        document: 'Tài liệu',
        days: 'Ngày',
        taskText: 'Nhiệm vụ',
        minutes: 'Phút',
        decentralizedPortTech: 'Kiến trúc kỹ thuật PoRT phi tập trung, kinh tế token BGB và ma trận khuyến khích kép.',
        auditReport: 'Báo cáo kiểm toán',
        faqSupport: 'Câu hỏi thường gặp & Hỗ trợ',
        telegram: 'Telegram',
        piece: 'Phần',
        faq: 'Câu hỏi thường gặp',
        faq1: 'Làm sao để liên kết Bitget API?',
        faq1Desc: 'Vào Bitget → Cài đặt → Quản lý API để lấy API Key và Secret. Chỉ bật quyền Spot Trading; tuyệt đối không bật quyền rút tiền. Dán khóa vào BitDeep DApp. Hoàn tất giao dịch thử 1 USDT là kích hoạt.',
        faq2: 'PoRT (Proof of Real Trading) là gì?',
        faq2Desc: 'PoRT là cơ chế cốt lõi của "giao dịch = đào coin". Hằng ngày hệ thống dùng Bitget API tự động mua-bán nhanh đồng được chỉ định (vd: BGB). Khi khối lượng giao dịch vượt Stake × 50%, hệ thống xác minh và kích hoạt thưởng trong ngày.',
        faq3: 'Hằng ngày có cần thủ công theo dõi không?',
        faq3Desc: 'Không cần. Sau khi liên kết API, hệ thống tự động hoàn thành nhiệm vụ giao dịch trong cửa sổ 24 giờ. Không cần thao tác thủ công; bạn có thể kiểm tra ở menu PoRT.',
        faq4: 'ALPHA và SIGMA khác nhau như thế nào?',
        faq4Desc: 'ALPHA (Cơ bản): stake 500 USDT, lợi suất 0.3–1.3%/ngày, chỉ mua 1 gói. SIGMA (Pro): stake 1,000 USDT, lợi suất 0.6–1.6%/ngày, tối đa 5 gói.',
        faq5: 'Tiền của tôi có an toàn không? Nền tảng có thể chạm vào tiền của tôi không?',
        faq5Desc: 'Tiền của bạn 100% nằm trong tài khoản Bitget của chính bạn. API chỉ cấp quyền đọc và giao dịch spot; hệ thống không thể rút hoặc chuyển bất kỳ khoản gốc nào.',
        faq6: 'Thu nhập hàng ngày được thanh toán khi nào?',
        faq6Desc: 'Sau khi PoRT xác minh thành công, thanh toán diễn ra vào ngày hôm sau. Hệ thống tự động giải phóng phần thưởng kép gồm USDT và điểm 10x Deep.',
        faq7: 'Thưởng Scout (Thưởng giới thiệu trực tiếp) được tính thế nào?',
        faq7Desc: 'Với mỗi tài khoản đang hoạt động bạn giới thiệu trực tiếp, bạn nhận thưởng cố định mỗi ngày: 1 USDT/ngày cho tài khoản ALPHA (500 USDT), 2 USDT/ngày cho tài khoản SIGMA (1,000 USDT), kéo dài đến khi chu kỳ của tài khoản đó kết thúc.',
        faq8: 'Làm sao để lên cấp (D1–D7)?',
        faq8Desc: 'Lên cấp dựa trên doanh số tích lũy của khu nhỏ (small-leg). Ví dụ: D1 cần 2,000 USDT, D3 cần 15,000 USDT, D7 (cấp cao nhất) cần 3,000,000 USDT. Cấp càng cao, thưởng chênh lệch cấp càng lớn (D7 tối đa 7 USDT/người/ngày).',
        faq9: 'Một chu kỳ kéo dài bao nhiêu ngày? Hết hạn thì xử lý thế nào?',
        faq9Desc: 'Một chu kỳ là 28 ngày. Sau khi chu kỳ kết thúc, bạn có thể chọn tiếp tục stake; phần thưởng được trả theo kết quả xác minh PoRT hàng ngày thực tế (lợi suất biến động).',
        faq10: 'Rút tiền có mất phí không?',
        faq10Desc:'Phí rút là 0. Nền tảng đưa phí rút trở lại pool để tăng độ dày LP, tạo vòng tuần hoàn lành mạnh.',
        bigArea: 'Khu vực lớn',
        smallArea: 'Khu vực nhỏ',
        enterWithdrawAmount: 'Nhập số tiền rút',
        all: 'Tất cả',
        available: 'Khả dụng',
        totalAmount: 'Tổng số tiền',
        confirmWithdraw: 'Xác nhận rút',
        withdrawRecord: 'Lịch sử rút',
        withdrawn: 'Đã rút',
        quickStartGuide:'Hướng dẫn bắt đầu nhanh',
        whitepaperGuide:'Whitepaper & Hướng dẫn',
        whitepaper:'Whitepaper',
        downloadPdf:'Tải xuống'
    },
    staking: {
        selectPackage: 'Đăng ký Ma trận',
        alpha: 'ALPHA',
        beginner: 'Người mới',
        sigma: 'SIGMA',
        professional: 'Chuyên nghiệp',
        popular: 'Phổ biến nhất',
        dailyReturn: 'Lợi nhuận hàng ngày',
        teamDepth: 'Độ sâu nhóm',
        limitPurchase: 'Giới hạn mua',
        layer: 'Tầng',
        copy: 'Phần',
        autoRenew: 'Tự động gia hạn',
        autoReinvest: 'Tự động tái đầu tư',
        subscribeAlpha: 'Đăng ký Alpha',
        subscribeSigma: 'Đăng ký Sigma',
        stakedAmount: 'Số tiền stake',
        stakedAmount2: 'Kỳ hạn',
        stakedAmount3: 'Tổng thu nhập',
        stakingTime: 'Thời gian stake',
        maturityTime: 'Thời gian đáo hạn',
        redeem: 'Rút',
        renew: 'Gia hạn',
        autoRenewActive: 'Tự động gia hạn đã bật',
        autoRenewInactive: 'Tự động gia hạn đã tắt',
        smartContract: 'Quản lý hợp đồng thông minh, tiền bị khóa trong 28 ngày và mở khi đáo hạn.'
    },
    me: {
        account: 'Tài khoản',
        my: 'Của tôi',
        staked: 'Đã stake',
        points: 'Điểm',
        consecutive: 'Ngày liên tiếp',
        withdraw: 'Rút',
        language: 'Ngôn ngữ',
        simplifiedChinese: 'Tiếng Trung giản thể',
        disconnectWallet: 'Ngắt kết nối ví',
        level: 'Cấp độ',
        joinDate: 'Ngày tham gia',
        bdId: 'BD-ID'
    },
    bindapi: {
        apiBinding: 'Liên kết API',
        bindDesc: 'Liên kết API của sàn để cho phép giao dịch định lượng',
        apiKey: 'API Key',
        apiSecret: 'API Secret',
        exchange: 'Sàn',
        futures: 'Hợp đồng tương lai',
        spot: 'Spot',
        readOnly: 'Chỉ đọc',
        bind: 'Liên kết',
        riskNote: 'API Key chỉ dùng để đồng bộ dữ liệu giao dịch, không lưu thông tin nhạy cảm',
        apiConnection: 'Kết nối API',
        bindExchangeApi: 'Liên kết API sàn',
        bitDeepRead: 'BitDeep đọc luồng lệnh từ tài khoản CEX để xác minh bằng chứng giao dịch thực (PoRT).',
        noWithdraw: 'Chúng tôi không bao giờ chạm vào việc rút tiền của bạn.',
        securityTip: 'Mẹo bảo mật · Vui lòng đọc kỹ',
        close: 'Đóng',
        withdraw: 'Rút',
        permission: 'Quyền',
        onlyEnable: 'Chỉ bật',
        spotTrading: 'Giao dịch Spot',
        read: 'Đọc',
        recommendedPartner: 'Đối tác đề xuất',
        zeroFee: '0% phí',
        activated: 'Đã kích hoạt',
        classicAccount: 'Tài khoản Cổ điển',
        unifiedAccount: 'Tài khoản Hợp nhất',
        bindBitgetApi: 'Liên kết Bitget API',
        upcoming: 'Sắp ra mắt',
        underAudit: 'Đang kiểm toán',
        expected: 'Dự kiến'
    },
    port: {
    portTaskCenter: 'Trung tâm nhiệm vụ PORT',
    dailyTask: 'Nhiệm vụ hàng ngày',
    verify: 'Xác minh',
    completed: 'Hoàn thành',
    incomplete: 'Chưa hoàn thành',
    verifyStandard: 'Tiêu chuẩn xác minh',
    tradingVolume: 'Khối lượng giao dịch',
    today: 'Hôm nay',
    deadline: 'Hạn chót',
    reward: 'Phần thưởng',
    startVerify: 'Bắt đầu xác minh',
    verifying: 'Đang xác minh',
    verified: 'Đã xác minh',
    insufficient: 'Không đủ',
    viewDetails: 'Xem chi tiết',
    taskList: 'Danh sách nhiệm vụ',
    allTasks: 'Tất cả nhiệm vụ',
    completedTasks: 'Hoàn thành',
    pendingTasks: 'Đang chờ',
    proofOfRealTrading: 'Bằng chứng giao dịch thực',
    todayTask: 'Nhiệm vụ hôm nay',
    todayStaticIncome: 'Thu nhập tĩnh hôm nay',
    points: 'Điểm',
    todayWindowClosesAt: 'Cửa sổ hôm nay đóng lúc',
    checkTaskStatus: 'Kiểm tra trạng thái nhiệm vụ',
    teamProgress: 'Tiến độ nhóm · Hôm nay',
    realtimePortCompletion: 'Hoàn thành PORT theo thời gian thực',
    completedText: 'Hoàn thành',
    pendingText: 'Đang chờ',
    realtimeApiValidationFlow: 'Thời gian thực · API · Luồng xác minh',
    rewardRemark1:'Global Dividend',
        rewardRemark2:'Level-Differential Bonus',
        rewardRemark3:'Scout Bonus',
        rewardRemark4:'Task Reward',
        rewardRemark5:'PoRT Task Success',
},
internet: {
    network: 'Mạng',
    treeBrowser: 'Trình duyệt cây',
    searchAddress: 'Tìm địa chỉ 0x... hoặc BD-ID',
    totalTradingVolume: 'Tổng khối lượng giao dịch',
    members: 'Thành viên',
    networkStructure: 'Cấu trúc mạng',
    allLevels: 'Tất cả cấp độ',
    addRemark: 'Thêm ghi chú',
    enterRemark: 'Vui lòng nhập ghi chú',
    cancel: 'Hủy',
    confirm: 'Xác nhận'
},
withdraw: {
    withdraw: 'Rút',
    usdtAsset: 'Tài sản USDT',
    withdrawAmount: 'Số tiền rút',
    availableBalance: 'Số dư khả dụng',
    fee: 'Phí',
    actualArrival: 'Thực nhận',
    submit: 'Gửi',
    withdrawSuccess: 'Rút thành công',
    withdrawFailed: 'Rút thất bại',
    processing: 'Đang xử lý',
    completed: 'Hoàn thành',
    withdrawHistory: 'Lịch sử rút'
},
popup: {
    taskUnfinished: 'Nhiệm vụ chưa hoàn thành',
    taskUnfinishedDesc: 'Dữ liệu giao dịch chưa đạt tiêu chuẩn PoRT hôm nay',
    todayTradingVolume: 'Khối lượng giao dịch hôm nay',
    remaining: 'Còn lại',
    toComplete: 'để hoàn thành nhiệm vụ hôm nay',
    tradingVolumeThreshold: '',
    deadline: 'Thời gian còn lại trước khi nhiệm vụ kết thúc',
    tryAgain: 'Thử lại sau',
    goTrade: 'Đi giao dịch',
    taskCompleted: 'Nhiệm vụ đã xác minh',
    taskCompletedDesc: 'Bằng chứng PoRT hôm nay đã được ghi thành công lên blockchain',
    rewardIssued: 'Phần thưởng đã được phát hành',
    complete: 'Hoàn thành',
    shareTitle: 'Chia sẻ lời mời',
    shareDesc: 'Mời bạn bè đăng ký, cả hai bên đều nhận thưởng',
    referralLink: 'Liên kết giới thiệu',
    qrCode: 'Mã QR',
    copyLink: 'Sao chép liên kết'
}
}